module.exports = __webpack_public_path__ + "img/223a8b6.webp";